import React from "react";

const Badge = (props) => {
  const { children, backgroundColor } = props;
  return (
    <div
      className="badge-comp"
      style={{ backgroundColor: backgroundColor ? backgroundColor : "var(--color-secondary)" }}
    >
      {children}
    </div>
  );
};

export default Badge;
